import Markdown from 'react-markdown'
import Image from 'next/image'
import styles from './content.module.scss'

import { VehicleModelContent } from '../MakeModelLanding'

export type ContentProps = {
  vehicleModelContent: VehicleModelContent
}

export const Content = ({ vehicleModelContent }: ContentProps) => {
  return (
    <section className={styles['content-section']}>
      <div className={styles.grid}>
        <div className={styles.intro}>
          <Markdown>
            {vehicleModelContent.secondBodyContent}
          </Markdown>
        </div>

        <div className={styles.section}>
          <div className={styles.text}>
            <div className={styles.content}>
              <Markdown>
                {vehicleModelContent.smallParagraph}
              </Markdown>
            </div>
          </div>
          {vehicleModelContent.smallParagraphImage && (
            <div className={styles.image}>
              <Image
                src={vehicleModelContent.smallParagraphImage}
                alt="Content image"
                layout="fill"
                objectFit="cover"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
